module.exports = __webpack_public_path__ + "media/images/logo-86ee1f64c57e697930c45dbb34e79c43.svg";